module.exports = __webpack_public_path__ + "img/60h40.95586fa2.svg";